import React, { Component } from 'react';

import { valueDefaults, dirtyDefaults, errorDefaults, validSteps } from './constants';
import GridContainer from '../../global/GridContainer';
import Step1 from './partials/Step1';
import Step2 from './partials/Step2';
import Step3 from './partials/Step3';
import withRouter from "../../helpers/withRouter";
import axios from "axios";
import parseStoryToFormValues from "../../helpers/parseStoryToFormValues";
import parseStoryImagesToFormValues from "../../helpers/parseStoryImagesToFormValues";
import CONSTANTS from "../../constants/constants";

class Share extends Component {
  constructor(props) {
    super(props);
    this.state = {
      storyId  : null,
      formStep : 1,
      apiError : false,
      values : { ...valueDefaults, },
      dirty  : { ...dirtyDefaults, },
      errors : { ...errorDefaults, },
      validSteps: { ...validSteps },
      defaultImages: [] // urls of loaded images
    }
  }

  componentDidMount() {
    const storyId = this.props.router.params.storyId;
    const customerId = window.theme?.customer?.id; //|| '6154892148986';
    if (storyId && customerId) {
      this.fetchStoryDetails(storyId, customerId)
      .then(res => {
        const story = res.data.data.trueStory;
        const defaultImages = story.images.map(image => image.imageUrl);

        this.setState({
          storyId: story._id,
          defaultImages // images previews, below image objects will be set
        });

        // set all loaded data besides images
        const initVals = parseStoryToFormValues(story);
        // set loaded images (Blob objects)
        parseStoryImagesToFormValues(story.images)
        .then(imageValues => {
          this.setState({
            values : {
              ...this.state.values,
              ...initVals,
              ...imageValues,
            },
          })
        });
      })
      .catch(console.error);
    }
  }

  fetchStoryDetails = (storyId, customerId) => 
    axios(`${CONSTANTS.baseUrl}api/truestories/detail/draft/${storyId}/${customerId}`)
  

  /**
   *
   * @param {*} value
   * @returns
   */
  setValue = value =>
    this.setState({
      values : {...this.state.values, ...value },
      errors : { ...errorDefaults },
      apiError : false,
    }, this.validate);

  /**
   *
   * @param {*} dirty
   * @returns
   */
  setDirty = dirty =>
    this.setState({ dirty : { ...this.state.dirty, ...dirty } }, this.validate);

  setStep1Dirty = () => new Promise((resolve, reject) => {
    this.setState({
      dirty : {
        ...this.state.dirty,
        petTypeDirty: true,
        breedDirty: true,
        petNameDirty: true,
        petAgeDirty: true,
      }
    }, resolve);
  })

  setStep2Dirty = () => new Promise((resolve, reject) => {
    this.setState({
      dirty : {
        ...this.state.dirty,
        contentDirty : true,
        image1Dirty: true,
      }
    }, resolve);
  })

  setStep3Dirty = () => new Promise((resolve, reject) => {
    this.setState({
      dirty : {
        ...this.state.dirty,
        productsDirty: true,
        termsAndConditionsDirty: true,
      }
    }, resolve);
  })

  /**
   *
   * @returns
   */
  advanceStep = () => {
    const { formStep } = this.state;

    if(formStep === 0) return;

    const setAllDirtyPromise = (
      (formStep === 1) ? this.setStep1Dirty()
    : (formStep === 2) ? this.setStep2Dirty()
    : this.setStep3Dirty()
    );

    setAllDirtyPromise
    .then(() => {
      this.validate()
      .catch((err) => {
        console.log(err)
      })
      .then(hasErrors => {
        // if we have errors we do not submit the form
        if(hasErrors) return;

        this.submitForm()
        .then(() => {
          const { formStep, validSteps } = this.state;
          const { router } = this.props;
          this.setState({ formStep : formStep + 1});

          if(this.state.formStep === 4 && Object.values(validSteps).every(step => step))
            router.navigate('/apps/truestories/story/thank-you')
        })
      })
    })
  }

  /**
   *
   * @returns
   */
  validate = () => new Promise((resolve, reject) => {
    const { formStep, dirty, values } = this.state;
    const stepErrors = {};

    if(formStep === 1) {
      const { petType, breed, petName, petAge } = values;
      if(dirty.petTypeDirty)
        stepErrors.petTypeRequiredError = petType === '';

      if(dirty.breedDirty)
        stepErrors.breedRequiredError = breed === '';

      if(dirty.petNameDirty)
        stepErrors.petNameRequiredError = petName === '';

      if(/[,.-]/.test(String(petAge)))
        stepErrors.petAgeFormatError = true;

      // For the age field (type="number") the value is "" if in the input is not number string,
      // e.g. "-", ".", "1.", "1-", "1-2" and etc. So this error will be shown not the one for
      // the wrong format.
      if(dirty.petAgeDirty)
        stepErrors.petAgeDirtyError = petAge === '';
    }
    else if(formStep === 2) {
      const { content, image1 } = values;
      if(dirty.contentDirty) {
        stepErrors.contentRequiredError = content === '';
        stepErrors.contentLengthMinError = content.length < 500;
      }

      if(dirty.image1Dirty) {
        // image1 is either a url if we are editing or a blob if we are creating
        stepErrors.image1RequiredError = !((image1 instanceof Blob) || (image1 instanceof String))
      }

    }
    else if(formStep === 3) {
      const { products, termsAndConditions } = values;
      if(dirty.productsDirty)
        stepErrors.productsRequiredError = products.length === 0;

      if(dirty.termsAndConditionsDirty)
        stepErrors.termsAndConditionsRequiredError = termsAndConditions.length === 0;
    }
      
    // set if the step is valid
    const stepInvalid = Object.values(stepErrors).some(v => v);
    this.setState({
      validSteps : {
        ...this.state.validSteps,
        [`step${formStep}`]: !stepInvalid,
      }
    });

    this.setState({ errors : {...errorDefaults, ...stepErrors } });

    resolve(Object.values(stepErrors).some(v => v));
  })

  /**
   *
   * @returns
   */
  submitForm = () => new Promise((resolve, reject) => {
    const { values, formStep } = this.state;
    const formData = new FormData();

    // match image1, image2, image3, image4, image5 to capture file names
    const reg = new RegExp(/^image[1|2|3|4|5]$/)
    Object.keys(values).forEach((key) => {
      if(reg.test(key) && values[key]) {
        formData.append(key, values[key], values[key].name);
      }
      else {
        if(key === 'products') {
          if(values[key] && values[key].length > 0) {
            formData.append(key, values[key].map(product => product.handle));
          }
        } else {
          formData.append(key, values[key]);
        }
      }
    });

    if(this.state.storyId)
      formData.append('storyId', this.state.storyId);

    let customerId  = '';
    let customerEmail = '';
    if (window.theme) {
      customerId = window.theme.customer.id;
      customerEmail = window.theme.customer.email;
    } else {
      customerId = window.ogShopifyConfig.customer.id;
      customerEmail = window.ogShopifyConfig.customer.email;
    }

    formData.append('customer_id', customerId)
    formData.append('customer_email', customerEmail)
    // else {
    //   formData.append('customer_id', '6154892148986')
    //   formData.append('customer_email', 'test@example.com')
    // }

    formData.append('current_step', formStep);

    const options = {
      method: 'POST',
      body: formData,
    };

    fetch(`${CONSTANTS.baseUrl}api/truestories/share-true-story`, options)
    .catch(err => {
      console.error(err);
      this.setState({ apiError : true });
      reject(err);
    })
    .then(res => res.json())
    .then(res => {
      console.log(res);
      if(this.state.storyId === null)
        this.setState({ storyId : res.data._id });
      resolve(res)
    })
  })

  editFormStep = formStep => {
    const { validSteps } = this.state;
    const priorStep = formStep - 1;
    // we are always allowed to edit step 1
    // otherwise we need to make sure the prior step is valid
    if(formStep === 1 || validSteps[`step${priorStep}`])
      this.setState({ formStep });
  }

  render() {
    const { storyId = '', formStep, apiError, values, errors } = this.state;
    const { breeds, petTypes, dietaryGoals } = this.props;
    return (
    <main className="share pt125 pt48@sm mb80">
      <GridContainer>
        <h1 className="fz64 fz32@sm lh1.1111 fw500 mb40 mt40">
          Tell Your True Story
        </h1>
        <form onSubmit={e => e.preventDefault()}>
          <input
            type="hidden"
            name="storyID"
            value={storyId ? storyId + 1 : ''}
          />
          <header className="share__section-heading df jcsb aic">
            <h2 className={`c-gray fz25@sm fz32 lh1.5 ${ formStep === 1 ? 'mb24' : '' }`}>
              <span className={`fw500 ${ formStep === 1 ? 'c-black' : '' }`}>Step 1</span> &mdash; Introduce Your Pet
            </h2>
            <span
              className={`curp tdu c-red fw500 fz14 ${ formStep === 1 ? 'dn' : ''}`}
              role="button"
              onClick={() => this.editFormStep(1)}
              onKeyDown={e => e.key === 'Enter' && this.editFormStep(1)}
              tabIndex="0"
            >
              Edit
            </span>
          </header>
          <Step1
            className={`${ formStep === 1 ? '' : 'dn' }`}
            values={values}
            errors={errors}
            setValue={this.setValue}
            setDirty={this.setDirty}
            nextStep={this.advanceStep}
            breeds={breeds}
            petTypes={petTypes.map(petType =>  ({ labelText : petType.name, value: petType._id, id: petType._id }))}
            dietaryGoals={dietaryGoals.map(dietaryGoal => ({id: dietaryGoal._id, name: dietaryGoal.name, value: dietaryGoal._id, labelText: dietaryGoal.name, className : 'w25%'}))}
          />
          <header className="share__section-heading df jcsb aic">
            <h2 className={`c-gray fz25@sm fz32 lh1.5 ${ formStep === 2 ? 'mb24' : '' }`}>
              <span className={`fw600 ${ formStep === 2 ? 'c-black' : '' }`}>Step 2</span> &mdash; Tell Your Story &amp; Add Images
            </h2>
            <span
              className={`curp tdu c-red fw500 fz14 ${ formStep === 2 ? 'dn' : ''}`}
              role="button"
              onClick={() => this.editFormStep(2)}
              onKeyDown={e => e.key === 'Enter' && this.editFormStep(2)}
              tabIndex="0"
            >
              Edit
            </span>
          </header>
          <Step2
            className={`${ formStep === 2 ? '' : 'dn' }`}
            values={values}
            defaultImages={this.state.defaultImages}
            errors={errors}
            setValue={this.setValue}
            setDirty={this.setDirty}
            nextStep={this.advanceStep}
          />
          <header className="share__section-heading df jcsb aic">
            <h2 className={`c-gray fz25@sm fz32 lh1.5 ${ formStep === 2 ? 'mb24' : '' }`}>
              <span className={`fw600 ${ formStep === 3 ? 'c-black' : '' }`}>Step 3</span> &mdash; What THK Products Do You Use?
            </h2>
            <span
              className={`curp tdu c-red fw500 fz14 ${ formStep === 3 ? 'dn' : ''}`}
              role="button"
              onClick={() => this.editFormStep(3)}
              onKeyDown={e => e.key === 'Enter' && this.editFormStep(3)}
              tabIndex="0"
            >
              Edit
            </span>
          </header>
          <Step3
            className={`${ formStep === 3 ? '' : 'dn' }`}
            values={values}
            errors={errors}
            setValue={this.setValue}
            setDirty={this.setDirty}
            nextStep={this.advanceStep}
            petTypes={petTypes}
          />
        </form>
        {apiError &&
        <div className="share__api-error">
          <p>
            There was an error submitting your form. Please try again.
          </p>
        </div>
        }
      </GridContainer>
    </main>
    )
  }
}

export default withRouter(Share);
